<div class="splash-wrap">
  <div class="splash-inner">
    <!-- <img src="assets/images/preloader.svg"> -->
    <img src="assets/images/processing.svg">
    <!-- <img src="assets/images/ball-bg.png">  -->
    <!-- <ng-lottie class="black-animation" *ngIf="isBrowser" [options]="options" /> -->
  </div>
</div>